import React, { memo, useState } from "react";

function sourceUrl(image) {
  return typeof image === "string" ? image : image?.url || image?.imageUrl || image?.image_url || image?.mediaUrl || image?.image || "";
}

export function thumbnailUrl(image, width = 600) {
  const supplied = image?.thumbnailUrl || image?.thumbnail_url;
  if (typeof supplied === "string" && /^(https?:\/\/|\/)/i.test(supplied)) return supplied;
  const original = sourceUrl(image);
  try {
    const url = new URL(original);
    // Signed URLs must be transformed and signed by the backend.
    if (url.hostname !== "ik.imagekit.io" || url.searchParams.has("ik-s")) return original;
    const previous = url.searchParams.get("tr");
    const size = Number.isFinite(width) && width > 0 ? Math.round(width) : 600;
    url.searchParams.set("tr", (previous ? previous + ":" : "") + "w-" + size + ",q-75");
    return url.toString();
  } catch { return original; }
}

export default memo(function MediaThumbnail({ image, src, alt, thumbnailWidth = 600, loading = "lazy", decoding = "async", onError, ...props }) {
  const source = image ?? src;
  const thumbnail = thumbnailUrl(source, thumbnailWidth);
  const [failedUrl, setFailedUrl] = useState(null);
  const original = sourceUrl(source) || thumbnail;
  const displayed = failedUrl === thumbnail ? original : thumbnail;
  return <img {...props} src={displayed || undefined} alt={alt} loading={loading} decoding={decoding}
    onError={(event) => {
      if (displayed !== original) setFailedUrl(thumbnail);
      else onError?.(event);
    }} />;
});
